import React, { Component } from "react";
import { optionMasterService } from "app/_services/OptionMasterService/optionMasterService";
import toastr from 'toastr'
import {
    Link
} from "react-router-dom";
import { ProjectService } from "app/_services/ProjectService/ProjectService";
import Prompt from 'app/Components/IEnergyPrompt/Prompt';
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

class EditCompany extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            error: {},
            id: this.props.match.params.id ? this.props.match.params.id : "",
            projectData: {},
            changeRoute:''
        }

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        this.setCompanyData();

    }

    async setCompanyData() {
        let response = await optionMasterService.optionMasterByID(this.state.id, 0);
        if (response && response.status) {
            this.setState({
                name: response.data.metaValue
            })
        } else {
            toastr.warning('Wrong')
        }
    }

    onChange(e) {

        let checkNagetiveForValue = e.target.value !== "" ? e.target.value : "";
        let flag = 0
        if (checkNagetiveForValue !== "") {
            flag = checkNagetiveForValue.slice(0, 1) === '-' ? 1 : 0
        }
        if (flag === 0) {
            this.setState({ [e.target.name]: e.target.value, changeRoute:1 })
        } else {
            this.setState({ [e.target.name]: "", changeRoute:1 })
        }
    }

    async onSubmit(e) {
        e.preventDefault();
        var obj = {
            "project_id": 0,
            "meta_key": this.state.name,
            "meta_value": this.state.name,
            "option_type": "company"
        }

        let data = await optionMasterService.updateOptionMaster(this.state.id, 0, obj);

        if (data && data.status === 1) {
            this.setState({
                changeRoute:''
            })
            toastr.success('Organisation Updated Successfully')
            this.props.history.push("/user-management/company");
        } else if (data && data.message) {
            toastr.warning(data.message)
        }

    }

    render() {
        const {
            projectData
        } = this.state;

        return (
            <div>
                <MainBreadcrumb
                    routeSegments={[
                        // { name: this.state.projectData.name, path: "/project/" + this.state.projectId + "/dashboard" },
                        { name: "User Management", path: "#" },
                        { name: "Organisation", path: "/user-management/company" },
                        { name: "Edit" }
                    ]}
                    breadCrumbsText="User_Management_Organization"
                />
                  <Prompt changes={this.state.changeRoute}></Prompt>
                <div className="row d-flex justify-content-center">
                    <div className="col-md-5">
                        <div className="card mt-5 mb-4">
                            <div className="card-body">
                                <div className="simple-card-title">
                                    <h3 class="text-capitalize mb-1">Edit Organisation</h3>
                                </div>
                                <form onSubmit={this.onSubmit}>
                                    <div className="row">
                                        <div className="col-md-12 form-group mb-3">
                                            <label>Organisation Name</label>
                                            <input
                                                name="name"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Project Name"
                                                onChange={this.onChange}
                                                casing-type value={this.state.name}
                                                required
                                            />
                                        </div>

                                        <div className="col-md-12 text-center">
                                            <Link to="/user-management/company" className="btn btn-secondary mr-2">Back</Link>
                                            {/* <button className="btn btn-secondary mr-2">Back</button> */}
                                            <button className="btn btn-primary ml-2">Update</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default EditCompany
